import React from 'react';
import TTLProxy from "../../common/TTLAsyncProxy";
import {TractorOwnerEndpoints} from "../../common/ProxyEndpoints";
import {TractorState} from '../../common/Constants';
import {Badge} from 'reactstrap';

class TractorUtils {

    static renderState(tractor) {

        let content;
        switch (tractor.state){
            case TractorState.Active:
                content = <Badge pill={true} color={"success"}>Active</Badge>;
                break;
            case TractorState.Faulted:
                content = <Badge pill={true} color={"warning"}>Inactive</Badge>;
                break;
        }

        return <h6>{content}</h6>;

    }

    static  fetchOwnerOperators(ownerId,idleOnly , exclude , include) {

        const proxy = TTLProxy.getInstance();

        return proxy.processRequest(TractorOwnerEndpoints.getOperators(ownerId).url,{
            include: [{
                model: 'tractor',
                attributes: ['id','name']
            }]
        }).then(response => {

            if(response.ok){

                const _operators = response.getPayload();

                let operators =  idleOnly ? _operators.filter(x => x.tractor == null) : _operators;

                if(exclude)
                    operators = operators.filter(x => exclude.indexOf(x.id) < 0);

                if(include){
                    include.forEach(v => {

                        if(operators.find(x => x.id == v) == null) {

                            let _tv = _operators.find(x => x.id == v);
                            if(_tv)
                                operators.unshift(_tv);
                        }

                    });
                }


                return operators;

            }

            return [];
        });
    }

}

export default TractorUtils;


// WEBPACK FOOTER //
// ./src/views/Tractors/TractorUtils.js